import Service from "../Service";

const resource = "TicUserStory/";

export default {
    save(story, requestID) {
        return Service.post(resource + "save", story, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    list(filter, requestID) {
        return Service.post(resource + "list", filter, {
            params: { requestID: requestID },
        });
    },

    saveVote(voteObj, requestID) {
        return Service.post(resource + "saveVote", voteObj, {
            params: { requestID: requestID }
        });
    },

    getVotes(usoID, requestID) {
        return Service.get(resource + "getVotes", {
            params: { usoID: usoID, requestID: requestID }
        });
    },

    closeVoting(obj, requestID) {
        return Service.post(resource + "closeVoting", obj, {
            params: { requestID: requestID }
        });
    },

    split(obj, requestID) {
        return Service.post(resource + "split", obj, {
            params: { requestID: requestID }
        });
    },

    moveKanban(obj, requestID) {
        return Service.post(resource + "moveKanban", obj, {
            params: { requestID: requestID }
        });
    },

    assignSprint(obj, requestID) {
        return Service.post(resource + "assignSprint", obj, {
            params: { requestID: requestID }
        });
    },

    unassignSprint(obj, requestID) {
        return Service.post(resource + "unassignSprint", obj, {
            params: { requestID: requestID }
        });
    },

    getHistory(usoID, requestID) {
        return Service.get(resource + "getHistory", {
            params: { usoID: usoID, requestID: requestID }
        });
    },

    isKanbanAdmin(requestID) {
        return Service.get(resource + "isKanbanAdmin", {
            params: { requestID: requestID }
        });
    }
};
